<!--首页 金额统计图标-->
<template>
    <div v-loading="loading" 
        element-loading-text="正在加载中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(23, 40, 90)" ref="dayMoneyEcharts" style="width:95%;height:95%;" class="center" />
</template>

<script>
import { mapState } from "vuex";
import store from "@/store";
var echarts = require("echarts");
export default {
    data() {
        return {
            orderSummaryDatas: null,
            axisData: [],
            moneyData: [],
            powerData: [],
            chart: null,
			loading: true,
        };
    },
    watch: {
        dayOrderSummary: {
            handler(val) {
                if (!val) {
                    this.$emit("search");
                    return;
                }
                let data = JSON.parse(JSON.stringify(val));
                this.orderSummaryDatas = data.sort((a, b) => {
                    return a.sum_date < b.sum_date ? -1 : 1;
                });
                this.axisData = [];
                this.moneyData = [];
                this.powerData = [];
                this.dealMonthData(this.orderSummaryDatas);
            },
            deep: true,
        },
    },
    computed: {
        ...mapState(["theme", "dayOrderSummary","multiple"]),
    },
    mounted() {
		this.getOrderSummary()
        this.chart = echarts.init(this.$refs.dayMoneyEcharts);
    },
    props: {},
    methods: {
        dataEcharts() {
            this.chart.setOption({
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "cross",
                        crossStyle: {
                            color: "#fff",
                        },
                    },
                },
				grid: {
				    left: "3%",
				    right: "4%",
				    bottom: "3%",
				    containLabel: true,
				},
                toolbox: {
					right: "5%",
                    feature: {
                        magicType: { show: true, type: ["line", "bar", "pie"] },
                        // restore: { show: true },
                        saveAsImage: { show: true },
                    },
                },
                legend: {
                    data: ["营业额", "电量"],
					left: 200,
					top: 20,
                },
                dataZoom: [
                    {
                        type: "inside", // 内置于坐标系中
                        startValue: this.axisData.length - 20,
                        xAxisIndex: [0],
                        moveOnMouseMove: true,
                        preventDefaultMouseMove: true,
                    },
                    {
                        type: "slider",
                        show: true,
                        startValue: this.axisData.length - 20,
                        xAxisIndex: [0],
                        backgroundColor: "rgba(155,155,155,0)",
                        borderColor: "#f5f3f6",
                        height: 10,
                    },
                ],
                xAxis: [
                    {
                        type: "category",
                        data: this.axisData,
                        axisLabel: {
                            margin: 34,
                            top: "10%",
                            textStyle: {
                                color: "#97a0d3",
                                align: "center",
                                fontSize: "10",
                                verticalAlign: "middle",
                                lineHeight: 30,
                                top: "10%",
                            },
                        },
                        axisTick: {
                            interval: 0,
                            length: 3,
                            //  alignWithLabel: true
                        },
                        axisPointer: {
                            type: "shadow",
                        },
                    },
                ],
                yAxis: [
                   {
                       type: "value",
                       name: "营业额",
                       // min: 0,
                       position: "left",
                       // interval: 100000,
                       axisLine: {
                           show: false,
                       },
					   splitNumber: 2,
                       axisLabel: {
                           formatter: "{value} 元",
                           textStyle: {
                               color: "#00abf5",
                           },
                       },
                   },
                   {
                       type: "value",
                       name: "电量",
                       // min: 0,
                       position: "right",
                       // interval: 100000,
                       axisLine: {
                           show: false,
                       },
					   splitNumber: 2,
                       axisLabel: {
                           formatter: "{value} KW·H",
                           textStyle: {
                               color: "#00abf5",
                           },
                       },
                   },
                ],
                series: [
                    {
                        name: "营业额",
                        type: "line",
                        data: this.moneyData,
						smooth: true,
                        markPoint: {
                            data: [
                                { type: "max", name: "最大值" },
                                { type: "min", name: "最小值" },
                            ],
                        },
                        markLine: {
                            data: [{ type: "average", name: "平均值" }],
                            label: {
                                position: "start",
                            },
                        },
                    },
                    {
                        name: "电量",
                        type: "line",
						smooth: true,
                        yAxisIndex: 1,
                        data: this.powerData,
                        markPoint: {
                            data: [
                                { type: "max", name: "最大值" },
                                { type: "min", name: "最小值" },
                            ],
                        },
                        markLine: {
                            data: [{ type: "average", name: "平均值" }],
                            label: {
                                position: "start",
                            },
                        },
                    },
                ],
            });
        },
        //处理获取到的每个月的数据
        dealMonthData(orderSummary) {
            if (!orderSummary) {
                return;
            }
            for (let i = 0; i < orderSummary.length; i++) {
                let data = JSON.parse(JSON.stringify(orderSummary[i]));
                this.axisData.push(data.sum_date);
                this.moneyData.push((data.money*this.multiple).toFixed(2));
                this.powerData.push((data.power*this.multiple).toFixed(2));
            }
            this.dataEcharts();
        },
		async getOrderSummary() {
			let now = new Date();
			now.setTime(now.getTime() - 24 * 60 * 60 * 1000 * 30);
			let lastData =
			    now.getFullYear() +
			    "-" +
			    (now.getMonth() + 1) +
			    "-" +
			    now.getDate();
			const start_time = new Date(lastData).getTime();
			const end_time = new Date();
		    let params = {
		        postData: {
		            end_time: end_time / 1000,
		            start_time: start_time / 1000,
		            sum_type: 0,
		        },
		        callback: () => {
		            this.loading = false;
		        },
		    };
		    await store.dispatch("getOrderSummary", params);
		},
    },
};
</script>
<style scoped>
.center {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
</style>
